module.exports = __webpack_public_path__ + "img/2.814abf52.jpg";